export default __webpack_public_path__ + "c2ee3fdbbfa4f4d60cdd29983797eb55.png";